import { render, staticRenderFns } from "./SubmitData.vue?vue&type=template&id=68f1fde5&scoped=true&"
import script from "./SubmitData.vue?vue&type=script&lang=js&"
export * from "./SubmitData.vue?vue&type=script&lang=js&"
import style0 from "./SubmitData.vue?vue&type=style&index=0&id=68f1fde5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f1fde5",
  null
  
)

export default component.exports